import { post } from '@services/method';
import { IUserDto } from '@services/auth';
import * as routes from '@configs/routes.json';
import { ISetPassword } from '@models';
import { ICreateUser, ResetPasswordPayload } from '@store/types';

export const create = (createUser: ICreateUser): Promise<void> => {
  return post(routes.api.user.create, {
    init: {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(createUser),
    },
  }).then(() => {});
};

export interface ILocaleDto {
  locale: string;
}

export const setLocale = (dto: ILocaleDto): Promise<void> => {
  return post(routes.api.user.locale, {
    init: {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(dto),
    },
  }).then(() => {});
};

interface ISetPasswordParams extends ISetPassword {}

export const setPassword = ({
  password,
  token,
}: ISetPasswordParams): Promise<IUserDto> => {
  return post(routes.api.user.setPassword, {
    init: {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ password: password, resetToken: token }),
    },
  }).then((response: Response) => response.json());
};

export const resetPassword = (payload: ResetPasswordPayload): Promise<void> => {
  return post(routes.api.user.resetPassword, {
    init: {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email: payload.email }),
    },
  }).then(() => {});
};
